import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=37a0951a&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.css?vue&type=style&index=0&id=37a0951a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0951a",
  null
  
)

export default component.exports